// the UI displays units but the API uses milliunits
export function serverInsulinToUserInsulin(milliunits: number) {
  return milliunits / 1000
}
